










































// ToDo: WEB-1369 Remove .menu-icon foundation class and replace with .svg icon.
import Vue from 'vue';
import { IHeaderMobileCommonComponent } from '@/common/interfaces/header.interface';
import TIcons from '../../../types/TIcons';
import config from '../../../../config';

export default Vue.extend({
  name: `HeaderMobileCommon`,
  data(): IHeaderMobileCommonComponent {
    return {
      cartLink: ``,
      loginLink: ``,
    };
  },
  computed: {
    accountIcon(): string {
      return TIcons.human;
    },
    cartIcon(): string {
      return TIcons.cartIcon;
    },
    logo(): string {
      return this.isPartnerShop ? TIcons.ringanaLogoPartner : TIcons.ringanaLogo;
    },
    logoClass(): string {
      return this.isPartnerShop
        ? `mobile-common__logo-img-partner`
        : `mobile-common__logo-img`;
    },
  },
  props: {
    cartItemsCount: {
      required: true,
      type: Number,
    },
    chosenLanguage: {
      required: true,
      type: String,
    },
    isLoggedIn: {
      default: false,
      type: Boolean,
    },
    isPartnerShop: {
      required: true,
      type: Boolean,
    },
    loading: {
      required: true,
      type: Boolean,
    },
  },
  mounted(): void {
    this.initAccountLinks();
  },
  methods: {
    initAccountLinks(): void {
      const cartLinks: { [index: string]: string } = config.header.links.cart;
      const loginLinks: { [index: string]: string } = config.header.links.login;

      this.cartLink = cartLinks[this.chosenLanguage];
      this.loginLink = loginLinks[this.chosenLanguage];
    },
    toggleMenu(): void {
      if(!this.loading) {
        this.$emit(`toggle:menu`);
      }
    },
  },
});
